<template>
  <div id="award-type-create" class="professional-preview-page">
    <!-- Professional Overlay Loading -->
    <v-overlay :value="OverlayLoadingFlag" class="professional-overlay">
      <div class="loading-container">
        <v-progress-circular
          indeterminate
          size="64"
          width="4"
          color="#1976d2"
        ></v-progress-circular>
        <p class="loading-text mt-4">Loading recognition details...</p>
      </div>
    </v-overlay>

    <!-- Professional Main Container -->
    <v-card class="main-preview-container" elevation="8">
      <!-- Professional Header Section -->
      <v-card-title class="professional-preview-header pa-6">
        <div class="header-content">
          <div class="title-section">
            <div class="main-title-wrapper">
              <v-icon size="32" color="#1976d2" class="mr-3"
                >mdi-check-circle</v-icon
              >
              <div class="title-text">
                <h1 class="preview-main-title">{{ PageTitle }}</h1>
              </div>
            </div>
          </div>
          <div class="action-buttons">
            <v-btn
              @click="closePrompt"
              color="#757575"
              elevation="2"
              rounded
              class="action-btn white--text"
            >
              <v-icon left size="18">mdi-close</v-icon>
              Close
            </v-btn>
          </div>
        </div>
      </v-card-title>

      <!-- Professional Content Container -->
      <v-card-text class="preview-main-content pa-6">
        <v-container>
          <!-- Professional Loading Section -->
          <div class="preview-loading-section" v-if="LoadingFlag">
            <div class="loading-wrapper">
              <v-progress-circular
                indeterminate
                color="#1976d2"
                size="48"
                width="4"
              ></v-progress-circular>
              <p class="loading-text mt-4">Loading recognition details...</p>
            </div>
          </div>

          <!-- Professional Form Container -->
          <v-form
            ref="form1"
            v-model="valid1"
            lazy-validation
            v-on:submit.prevent="confirmAlert"
            class="professional-preview"
          >
            <div class="preview-content-wrapper" v-if="record != ''">
              <!-- Category Details Card -->
              <v-card class="details-card mb-6" elevation="3">
                <v-card-title class="details-header">
                  <v-icon size="24" color="#1976d2" class="mr-3"
                    >mdi-clipboard-text</v-icon
                  >
                  <span class="section-title">Recognition Information</span>
                </v-card-title>
                <v-card-text class="pa-6">
                  <v-row>
                    <v-col cols="12" sm="6" lg="4">
                      <div class="detail-item">
                        <label class="detail-label">Status</label>
                        <v-chip
                          :color="record.RecognitionStatusColor"
                          dark
                          small
                          class="status-chip"
                        >
                          <v-icon left size="16">mdi-check-circle</v-icon>
                          {{ record.RecognitionStatusTxt }}
                        </v-chip>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4">
                      <div class="detail-item">
                        <label class="detail-label">Recognition Date</label>
                        <p class="detail-value">
                          <v-icon size="16" color="#666" class="mr-1"
                            >mdi-calendar</v-icon
                          >
                          {{ record.RecognitionDate }}
                        </p>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4">
                      <div class="detail-item">
                        <label class="detail-label">Category Title</label>
                        <p class="detail-value">{{ record.CategoryTitle }}</p>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4">
                      <div class="detail-item">
                        <label class="detail-label">Category Description</label>
                        <p class="detail-value">
                          {{ record.CategoryDescription }}
                        </p>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4">
                      <div class="detail-item">
                        <label class="detail-label">Category Type</label>
                        <p class="detail-value">{{ record.CategoryTypeTxt }}</p>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4">
                      <div class="detail-item">
                        <label class="detail-label">LO Name</label>
                        <p class="detail-value">{{ record.LomName }}</p>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4">
                      <div class="detail-item">
                        <label class="detail-label">Portfolio Type</label>
                        <p class="detail-value">{{ record.PortfolioName }}</p>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4">
                      <div class="detail-item">
                        <label class="detail-label">Gift Name</label>
                        <p class="detail-value">{{ record.GiftName }}</p>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4">
                      <div class="detail-item">
                        <label class="detail-label">Submitted At</label>
                        <p class="detail-value">
                          <v-icon size="16" color="#666" class="mr-1"
                            >mdi-clock-outline</v-icon
                          >
                          {{ record.CreatedAt }}
                        </p>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4">
                      <div class="detail-item">
                        <label class="detail-label">Updated At</label>
                        <p class="detail-value">
                          <v-icon size="16" color="#666" class="mr-1"
                            >mdi-update</v-icon
                          >
                          {{ record.UpdatedAt }}
                        </p>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div class="detail-item">
                        <label class="detail-label"> Description</label>
                        <p class="detail-value">
                          {{ record.RecognitionDescription || Description }}
                        </p>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- President Details Card -->
              <v-card
                class="details-card mb-6"
                elevation="3"
                v-if="LomData != '' && LomData.President"
              >
                <v-card-title class="details-header">
                  <v-icon size="24" color="#1976d2" class="mr-3"
                    >mdi-account-tie</v-icon
                  >
                  <span class="section-title">President Details</span>
                </v-card-title>
                <v-card-text class="pa-6">
                  <v-row align="center">
                    <v-col cols="12" sm="3" md="2" class="text-center">
                      <v-avatar size="100" class="president-avatar">
                        <img
                          :src="LomData.President.MemberImagePath"
                          alt="President"
                        />
                      </v-avatar>
                    </v-col>
                    <v-col cols="12" sm="9" md="10">
                      <v-row>
                        <v-col cols="12" sm="6" lg="6">
                          <div class="detail-item">
                            <label class="detail-label">President Name</label>
                            <p class="detail-value">
                              {{ LomData.President.LomPresidentFullName }}
                            </p>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6" lg="6">
                          <div class="detail-item">
                            <label class="detail-label"
                              >President Membership ID</label
                            >
                            <p class="detail-value">
                              {{ LomData.President.LomPresidentMembershipId }}
                            </p>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Member Details Card -->
              <v-card
                class="details-card mb-6"
                elevation="3"
                v-if="MemberId > 0 && member != ''"
              >
                <v-card-title class="details-header">
                  <v-icon size="24" color="#1976d2" class="mr-3"
                    >mdi-account-circle</v-icon
                  >
                  <span class="section-title">Member Details</span>
                </v-card-title>
                <v-card-text class="pa-6">
                  <v-row align="center">
                    <v-col cols="12" sm="3" md="2" class="text-center">
                      <v-avatar size="100" class="member-avatar">
                        <img :src="member.photo" alt="Member Photo" />
                      </v-avatar>
                    </v-col>
                    <v-col cols="12" sm="9" md="10">
                      <v-row>
                        <v-col cols="12" sm="6" md="3">
                          <div class="detail-item">
                            <label class="detail-label">Member Name</label>
                            <p class="detail-value">
                              {{ member.member_name }}
                            </p>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <div class="detail-item">
                            <label class="detail-label">Membership ID</label>
                            <p class="detail-value">
                              {{ member.membership_id }}
                            </p>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <div class="detail-item">
                            <label class="detail-label">Date of Birth</label>
                            <p class="detail-value">{{ member.member_dob }}</p>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <div class="detail-item">
                            <label class="detail-label">Mobile No</label>
                            <p class="detail-value">{{ member.mobile_no }}</p>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <div class="detail-item">
                            <label class="detail-label">Email ID</label>
                            <p class="detail-value">{{ member.email_id }}</p>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="8">
                          <div class="detail-item">
                            <label class="detail-label">Address</label>
                            <p class="detail-value">{{ member.address_txt }}</p>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Attachments Card -->
              <v-card class="attachments-card mb-6" elevation="3">
                <v-card-title class="details-header">
                  <div class="attachments-header-content">
                    <div class="attachments-title-section">
                      <v-icon size="24" color="#1976d2" class="mr-3"
                        >mdi-paperclip</v-icon
                      >
                      <span class="section-title">
                        {{
                          record.CategoryType == 3
                            ? "Uploaded Files"
                            : "Attachments"
                        }}
                      </span>
                      <small class="ml-2 grey--text"
                        >(max - {{ CategoryMaxCount }})</small
                      >
                    </div>
                  </div>
                </v-card-title>
                <v-card-text class="pa-6">
                  <!-- For Category Type 3: Display Uploaded Files -->
                  <template
                    v-if="record.CategoryType == 3 && AllProject.length > 0"
                  >
                    <v-row>
                      <v-col
                        v-for="(data, index) in AllProject"
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                        :key="index"
                      >
                        <v-card class="attachment-item-card" elevation="2">
                          <v-card-text class="pa-3">
                            <div class="uploaded-file-preview mb-3">
                              <viewer rebuild :images="[data.FileUrl]">
                                <img
                                  :src="data.FileUrl"
                                  class="uploaded-file-image"
                                  style="
                                    width: 100%;
                                    height: 150px;
                                    object-fit: cover;
                                    cursor: pointer;
                                    border-radius: 4px;
                                  "
                                />
                              </viewer>
                            </div>
                            <div class="file-details">
                              <div class="detail-row mb-2">
                                <v-icon size="14" color="#666" class="mr-1"
                                  >mdi-file-image</v-icon
                                >
                                <span
                                  class="detail-value"
                                  style="font-size: 12px; word-break: break-all"
                                  >{{ data.FileName }}</span
                                >
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </template>

                  <!-- For Other Category Types: Display Event Cards -->
                  <template
                    v-else-if="
                      record.CategoryType != 3 && AllProject.length > 0
                    "
                  >
                    <v-row>
                      <v-col
                        v-for="(data, index) in AllProject"
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                        :key="index"
                      >
                        <v-card class="attachment-item-card" elevation="2">
                          <v-card-text class="pa-3">
                            <div class="event-images mb-3">
                              <viewer rebuild :images="data.EventPhoto">
                                <div class="images-grid">
                                  <img
                                    class="event-image"
                                    width="60"
                                    height="60"
                                    :src="src"
                                    :key="src"
                                    v-for="src in data.EventPhoto"
                                  />
                                </div>
                              </viewer>
                            </div>
                            <div class="event-details">
                              <div class="detail-row mb-2">
                                <v-icon size="14" color="#666" class="mr-1"
                                  >mdi-calendar</v-icon
                                >
                                <span class="detail-value">{{
                                  data.EventDate
                                }}</span>
                              </div>
                              <div class="detail-row mb-2">
                                <v-icon size="14" color="#666" class="mr-1"
                                  >mdi-briefcase</v-icon
                                >
                                <span class="detail-value">{{
                                  data.PortfolioName
                                }}</span>
                              </div>
                              <div class="detail-row">
                                <v-icon size="14" color="#666" class="mr-1"
                                  >mdi-calendar-star</v-icon
                                >
                                <span class="detail-value">{{
                                  data.EventName
                                }}</span>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </template>

                  <div v-else class="no-attachments-state">
                    <v-icon size="64" color="#ccc">mdi-paperclip-off</v-icon>
                    <p class="mt-3 grey--text">No attachments found</p>
                  </div>
                </v-card-text>
              </v-card>

              <!-- Description History Card -->
              <v-card class="history-card mb-6" elevation="3">
                <v-card-title class="details-header">
                  <v-icon size="24" color="#1976d2" class="mr-3"
                    >mdi-history</v-icon
                  >
                  <span class="section-title">Description History</span>
                </v-card-title>
                <v-card-text class="pa-6">
                  <div
                    v-if="recordData.DescriptionHistory"
                    v-html="recordData.DescriptionHistory"
                    class="history-content"
                  ></div>
                  <div v-else class="no-history-state">
                    <v-icon size="48" color="#ccc">mdi-text-box-remove</v-icon>
                    <p class="mt-3 text-danger">
                      No previous description found
                    </p>
                  </div>
                </v-card-text>
              </v-card>

              <!-- Approval Actions Card -->
              <v-card
                class="approval-card mb-6"
                elevation="3"
                v-if="recordData.ApprovalFlag"
              >
                <v-card-title class="details-header">
                  <v-icon size="24" color="#1976d2" class="mr-3"
                    >mdi-check-decagram</v-icon
                  >
                  <span class="section-title">Approval Actions</span>
                </v-card-title>
                <v-card-text class="pa-6">
                  <v-row>
                    <v-col cols="12">
                      <div class="input-section">
                        <h4 class="input-label">Comments / Description</h4>
                        <v-textarea
                          v-model="ApprovalDescription"
                          placeholder="Enter your comments here..."
                          outlined
                          dense
                          rows="4"
                          clearable
                          prepend-inner-icon="mdi-comment-text"
                        ></v-textarea>
                      </div>
                    </v-col>
                    <v-col cols="12" class="text-center">
                      <div class="approval-actions">
                        <v-btn
                          color="#43aa8b"
                          elevation="8"
                          rounded
                          large
                          class="approval-btn white--text mr-3"
                          @click="updateApprovalStatus(1)"
                          :loading="ApproveLoadingFlag"
                        >
                          <v-icon left>mdi-check-circle</v-icon>
                          Approve
                        </v-btn>
                        <v-btn
                          color="#f44336"
                          elevation="8"
                          rounded
                          large
                          class="approval-btn white--text"
                          @click="updateApprovalStatus(2)"
                          :loading="RejectLoadingFlag"
                        >
                          <v-icon left>mdi-close-circle</v-icon>
                          Reject
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Close Action Section -->
              <div class="close-section">
                <v-card class="close-card" elevation="3">
                  <v-card-text class="text-center pa-6">
                    <v-btn
                      @click="closePrompt"
                      elevation="8"
                      rounded
                      large
                      color="#757575"
                      class="close-btn white--text"
                    >
                      <v-icon left>mdi-close-circle</v-icon>
                      Close
                    </v-btn>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    previewRecordPrompt: {
      required: true,
      type: Boolean,
    },
    recordData: {
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SubmitFlag: false,
      OverlayLoadingFlag: false,
      ApprovalDescription: "", // textarea model
      ApprovalLoading: false, // button loading state
      UploadFlag: false,
      ResultFlag: false,
      ApproveLoadingFlag: false,
      RejectLoadingFlag: false,
      record: {},
      LomData: {},
      member: {},

      AllProject: [],
      row: {},

      Description: "",
      addAttachmentPrompt: false,

      LomCode: 0,
      CategoryMaxCount: 0,

      // MemberIdRules: [(v) => !!v || "Member is required"],
      MemberId: "",
      MemberIdOptions: [],
      MemberIdOptionsLoading: false,

      YearCode: "",
      RoleId: "",
      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        this.YearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        var RoleId = this.$session.get("RoleId");
        RoleId = RoleId == (null || undefined) ? "" : RoleId;
        this.RoleId = RoleId;
        console.log("RoleId=" + RoleId);

        this.pageData();
      }
    },
    MemberIdOptions: function () {
      console.log("watch MemberIdOptions called.");

      this.MemberIdOptionsLoading = false;
      var tr = this.record;
      this.MemberId = tr.MemberId;
    },
    MemberId: function () {
      console.log("watch MemberId");
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      var idx = this.MemberIdOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var member = this.MemberIdOptions[idx];
        console.log({ member });
      }
      this.getMemberDetails();
    },
    record: function () {
      console.log("Watch record called");
      var tr = this.record;
      console.log("tr =" + JSON.stringify(tr));

      this.Description = tr.RecognitionDescription;
      this.CategoryMaxCount = tr.CategoryMaxCount;
      this.LomCode = tr.LomId;

      this.getLomDetails();
      this.getMemberIdOptions();
      this.AllProject = [];

      tr.EventDetails.forEach((row) => {
        if (row["IsUploadedFile"]) {
          // For uploaded files (category type 3)
          this.AllProject.push({
            AttachmentId: row["AttachmentId"],
            FileName: row["FileName"],
            FilePath: row["FilePath"],
            FileUrl: row["FileUrl"],
            IsUploadedFile: true,
          });
        } else {
          // For event-based attachments
          this.AllProject.push({
            EventId: row["EventId"],
            EventName: row["EventName"],
            EventDate: row["EventDate"],
            PortfolioId: row["PortfolioId"],
            PortfolioName: row["PortfolioName"],
            EventDescription: row["EventDescription"],
            EventPhoto: row["EventImagesArray"],
            IsUploadedFile: false,
          });
        }
      });

      console.log("AllProject =" + JSON.stringify(this.AllProject));
    },
  },
  mounted() {},
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "np_recognition",
        Action: "approval",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideApprovalRecordPrompt", this.ResultFlag);
    },
    pageData() {
      console.log("pageData called");

      console.log("recordData =" + JSON.stringify(this.recordData));
      var id = this.recordData.RecognitionId;

      console.log({ id });
      if (id > 0) {
        this.getTableRecords(id);
      }
    },
    updateApprovalStatus(Status) {
      console.log("submitForm is called");

      console.log({ Status });

      var message = "";

      var tr = this.recordData;
      console.log({ tr });

      var id = tr.RecognitionId;
      console.log(id);

      if (Status > 0 && id > 0) {
        switch (Status) {
          case 1:
            this.ApproveLoadingFlag = true;
            break;

          case 2:
            this.RejectLoadingFlag = true;
            break;

          default:
            break;
        }

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/recognition/approval-update";
        var upload = {
          UserInterface: Status,
          Recognition: id,
          Description: this.ApprovalDescription,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.StatusFlag = false;
        this.ResultFlag = false;

        const thisIns = this;
        var output = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            switch (Status) {
              case 1:
                thisIns.ApproveLoadingFlag = false;
                break;

              case 2:
                thisIns.RejectLoadingFlag = false;
                break;

              default:
                break;
            }

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            if (flag == 1) {
              thisIns.StatusFlag = true;
              thisIns.ResultFlag = true;
              thisIns.sweetAlert("success", output, true);
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
          });
      } else {
        if (Status == null || Status == "") {
          message = "Status is invalid. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    getLomDetails() {
      console.log("getLomDetails called");
      this.SubmitFlag = true;

      var upload = {
        UserInterface: 1,
        Lom: this.LomCode,
      };
      console.log("upload=" + JSON.stringify(upload));

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;

      var add_url = server_url + "api/lom/show";
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      this.SubmitFlag = true;
      this.LomData = {};

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.SubmitFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);
          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.LomData = records;
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SubmitFlag = false;
        });
    },
    getTableRecords(id) {
      console.log("getTableRecords called");
      console.log({ id });

      if (id > 0) {
        this.SubmitFlag = true;
        this.LoadingFlag = true;
        this.OverlayLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/recognition/show";

        var upload = {
          UserInterface: 1,
          Recognition: id,
        };

        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;
            thisIns.OverlayLoadingFlag = false;

            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.SubmitFlag = false;
              console.log({ records });

              thisIns.record = records;
              console.log("record = " + JSON.stringify(thisIns.record));

              thisIns.toast("success", output);
            } else {
              thisIns.SubmitFlag = false;
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            thisIns.SubmitFlag = false;
            thisIns.OverlayLoadingFlag = false;
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Np-Recognition Details not found.";
        this.toast("error", message);
      }
    },
    getMemberIdOptions() {
      console.log("getMemberIdOptions called");
      this.MemberIdOptionsLoading = true;
      var selectbox1_source = "MemberId";
      var selectbox1_destination = "MemberIdOptions";
      var selectbox1_url = "api/members/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        LomCode: this.LomCode,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getMemberDetails() {
      console.log("getMemberDetails called");
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      var idx = this.MemberIdOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var member = this.MemberIdOptions[idx];
        console.log("member=" + JSON.stringify(member));
        this.member = member;
      }
    },
  },

  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
// Professional Preview Page Styles
.professional-preview-page {
  background-color: #f5f7fa;
  min-height: 100vh;

  // Professional Overlay
  .professional-overlay {
    z-index: 9999 !important;

    .loading-container {
      text-align: center;
      color: white;

      .loading-text {
        font-size: 1.1rem;
        font-weight: 500;
        margin: 0;
      }
    }
  }

  // Main Preview Container
  .main-preview-container {
    border-radius: 12px !important;
    overflow: hidden;
    background: white;
    box-shadow: 0 6px 30px rgba(0, 0, 0, 0.1) !important;
  }

  // Professional Header Styles
  .professional-preview-header {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-bottom: 1px solid #e3f2fd;

    .header-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .title-section {
        flex: 1;

        .main-title-wrapper {
          display: flex;
          align-items: center;

          .title-text {
            .preview-main-title {
              font-size: 1.8rem;
              font-weight: 700;
              color: #2c3e50;
              margin: 0;
              font-family: "Roboto", sans-serif;
              line-height: 1.2;
            }
          }
        }
      }

      .action-buttons {
        .action-btn {
          font-weight: 500;
          text-transform: none;
          padding: 0 20px;
          height: 40px;

          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          }
        }
      }
    }
  }

  // Preview Content Styles
  .preview-main-content {
    background: #f5f7fa;
  }

  // Preview Loading
  .preview-loading-section {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;

    .loading-wrapper {
      text-align: center;

      .loading-text {
        font-size: 1.1rem;
        color: #666;
        font-weight: 500;
        margin: 0;
      }
    }
  }

  // Professional Preview
  .professional-preview {
    .preview-content-wrapper {
      .details-card,
      .attachments-card,
      .history-card,
      .approval-card,
      .close-card {
        border-radius: 12px !important;
        border: 1px solid #e0e0e0;
      }
    }
  }

  // Details Cards
  .details-card,
  .attachments-card,
  .history-card,
  .approval-card {
    .details-header {
      background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
      border-bottom: 1px solid #e0e0e0;
      padding: 1.5rem;

      .section-title {
        font-size: 1.3rem;
        font-weight: 600;
        color: #2c3e50;
      }

      .attachments-header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .attachments-title-section {
          display: flex;
          align-items: center;
        }
      }
    }

    .detail-item {
      margin-bottom: 1rem;

      .detail-label {
        font-size: 0.85rem;
        font-weight: 600;
        color: #666;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 0.25rem;
        display: block;
      }

      .detail-value {
        font-size: 1rem;
        color: #2c3e50;
        font-weight: 500;
        margin: 0;
        line-height: 1.4;
        display: flex;
        align-items: center;
      }

      .status-chip {
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
    }
  }

  // President and Member Avatars
  .president-avatar,
  .member-avatar {
    border: 3px solid #e3f2fd;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    img {
      object-fit: cover;
    }
  }

  // Attachments Card
  .attachments-card {
    .attachment-item-card {
      border-radius: 8px !important;
      position: relative;
      transition: transform 0.2s, box-shadow 0.2s;
      border: 1px solid #e0e0e0 !important;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
      }

      .event-images {
        .images-grid {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 0.5rem;

          .event-image {
            border-radius: 4px;
            border: 1px solid #e0e0e0;
            object-fit: cover;
            transition: transform 0.2s;

            &:hover {
              transform: scale(1.05);
            }
          }
        }
      }

      .event-details {
        .detail-row {
          display: flex;
          align-items: center;
          font-size: 0.85rem;

          .detail-value {
            color: #2c3e50;
            font-weight: 500;
          }
        }
      }
    }

    .no-attachments-state {
      text-align: center;
      padding: 3rem;
    }
  }

  // History Card
  .history-card {
    .history-content {
      background: #fafafa;
      padding: 1rem;
      border-radius: 8px;
      border: 1px solid #e0e0e0;
      line-height: 1.6;
      color: #2c3e50;
    }

    .no-history-state {
      text-align: center;
      padding: 2rem;
    }
  }

  // Approval Card
  .approval-card {
    .input-section {
      .input-label {
        font-size: 1rem;
        font-weight: 600;
        color: #2c3e50;
        margin-bottom: 0.5rem;
      }
    }

    .approval-actions {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 0.5rem;

      .approval-btn {
        min-width: 150px;
        font-weight: 600;
        text-transform: none;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
        }
      }
    }
  }

  // Close Section
  .close-section {
    margin-top: 2rem;

    .close-card {
      border: 2px solid #e3f2fd;
      background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);

      .close-btn {
        min-width: 150px;
        font-weight: 600;
        text-transform: none;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
        }
      }
    }
  }

  // Responsive Design
  @media (max-width: 768px) {
    .main-preview-container {
      margin: 0.5rem;
      border-radius: 8px !important;
    }

    .professional-preview-header {
      padding: 1rem !important;

      .header-content {
        flex-direction: column;
        gap: 1rem;
        align-items: flex-start;

        .title-section .main-title-wrapper .title-text .preview-main-title {
          font-size: 1.3rem;
        }

        .action-buttons {
          align-self: flex-start;
        }
      }
    }

    .preview-main-content {
      padding: 1rem !important;
    }

    .details-header {
      padding: 1rem !important;

      .section-title {
        font-size: 1.1rem !important;
      }
    }

    .approval-actions,
    .close-btn {
      width: 100%;

      .approval-btn,
      .close-btn {
        width: 100%;
        margin: 0.25rem 0 !important;
      }
    }

    .president-avatar,
    .member-avatar {
      size: 80px !important;
    }
  }
}
</style>
